export default "__VITE_ASSET__KYZQF18V__"